module.exports = {"TXTMOB_Games_available":{"id":"TXTMOB_Games_available","defaultMessage":"Spiele verfügbar"}}